export enum EReadToWriteMode {
  write = 'write',
  read = 'read',
  noData = 'noData',
  formDataLoading = 'formDataLoading',
}
